/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import LicencesDescription from "views/OmegaBangles/Section/LicencesDescripotion.js";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import OmegaFooter from "views/OmegaBangles/Section/OmegaFooter";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);

export default function Licences() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();

  const currentUrl = "https://omegabangles.com/license";
  const seoTitle = "Licenses & Certifications | OMEGA BANGLES";
  const seoDescription =
    "View the licenses, registrations, and business certifications of OMEGA BANGLES PRIVATE LIMITED. Learn more about our business authenticity and compliance details.";
  const seoKeywords =
    "OMEGA BANGLES license, OMEGA BANGLES certifications, jewellery business license, bangles manufacturer registration, business certifications India";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const licenseSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Licenses & Certifications",
    url: currentUrl,
    description: seoDescription,
    publisher: {
      "@type": "Organization",
      name: "OMEGA BANGLES",
      logo: {
        "@type": "ImageObject",
        url: ogImage,
      },
    },
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="OMEGA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(licenseSchema)}
        </script>
      </Helmet>
      <Header
        brand="Home"
        links={<HeaderLinks dropdownHoverColor="warning" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "warning",
        }}
      />
      <Parallax
        image={require("assets/img/bg2.jpg").default}
        // style={{backgrounColor: "#3c4858"}}
        filter="dark"
        small
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={10}
              sm={10}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter,
              )}
            >
              <h1
                style={{
                  color: "#fff",
                  fontFamily: "Tahoma",
                  fontWeight: "bold",
                }}
              >
                Licenses & Certifications
              </h1>
              <h4 style={{ color: "#fff" }}></h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main)}>
        <div className={classes.container}>
          <LicencesDescription />
          <br />
        </div>
      </div>
      <OmegaFooter />
    </div>
  );
}
